import {isEmpty, isObject, isNull, keys} from 'lodash';
import Swal from 'sweetalert2';
import {ERROR_MESSAGES} from 'configs';

export const getErrorMessage = (code, message) => {
  if (ERROR_MESSAGES.hasOwnProperty(code)) return ERROR_MESSAGES[code];
  if (!isEmpty(message)) return message;

  return ERROR_MESSAGES.not_found;
};

/*
{
  animation: false,
  showConfirmButton: true,
  confirmButtonColor: '#023b89',
  confirmButtonText: 'OK',
  showCancelButton: false,
  cancelButtonColor: '#6c757d',
  cancelButtonText: 'Cancel',
  type: '',
  title: '',
  text: '',
}
 */

const optionBase = {
  animation: false,
  confirmButtonColor: '#023b89',
  confirmButtonText: 'OK',
  cancelButtonColor: '#6c757d',
  cancelButtonText: 'Cancel',
};

const swalBase = Swal.mixin(optionBase);

export const alertSuccess = (options = {}) => {
  return swalBase({
    allowOutsideClick: false,
    confirmButtonColor: '#023b89',
    confirmButtonText: 'OK',
    type: 'success',
    title: 'Success',
    ...options,
  });
};

export const alertError = (options = {}) => {
  return swalBase({
    allowOutsideClick: false,
    confirmButtonColor: '#6c757d',
    confirmButtonText: 'Close',
    type: 'error',
    title: 'Oops...',
    text: 'Something went wrong...',
    ...options,
  });
};

export const alertBase = (options = {}) => {
  if (!isObject(options)) {
    options = {};
  }

  if (isEmpty(options) || isEmpty(options.type)) {
    if (!isNull(options.type)) {
      options.type = 'success';
    }
  }

  if (options.type === 'error') {
    return alertError(options);
  } else if (options.type === 'success') {
    return alertSuccess(options);
  } else {
    return swalBase({
      allowOutsideClick: false,
      confirmButtonColor: '#023b89',
      confirmButtonText: 'OK',
      ...options,
    });
  }
};

export const alertConfirm = (options = {}) => {
  return swalBase({
    showConfirmButton: true,
    showCancelButton: true,
    type: 'warning',
    title: 'Confirm',
    text: 'Are you sure you want',
    ...options,
  });
};

export const alertByError = (error, options = {}) => {
  const {code, message} = error;

  if (message) {
    // default error
    if (typeof message === 'string') {
      options.text = getErrorMessage(code, message);
    }
    // validation error
    else if (typeof message === 'object') {
      let html = [];

      keys(message).forEach((key) => {
        html.push(getErrorMessage(key, message[key]));
      });

      /*values(message).forEach((item) => {
        html = html.concat(item);
      });*/

      options.html = html.join('<br />');
    }
  }

  return swalBase({
    type: 'error',
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonColor: '#6c757d',
    cancelButtonText: 'Close',
    title: 'Oops...',
    text: 'Something went wrong...',
    ...options,
  });
};
